const decimalFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false
})

const percentFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
    useGrouping: false
})

const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
})

const countFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
})

/**
 * Format a nubmer for use in an HTML number input box.
 * @param {Number} value A float value to format as a decimal number, no commas
 * @returns A formatted float value ready for an number input box.
 */
export const formatDecimal = (value) => {
    if ((value == undefined) || (value == null)) {
        value = 0
    }

    let decimal = parseFloat(value.toString().replace(/[^0-9\.\-]/g, ''))
    if (isNaN(decimal)) {
        decimal = 0
    }

    return decimalFormatter.format(decimal)
}

/**
 * Format a nubmer to a percent for use in a number HTML input box of other UI dsiplay.
 * @param {Number} value A float value to format to percent, four decimals, no commas
 * @returns A formatted percent value ready for display in the UI.
 */
 export const formatPercent = (value) => {
    if ((value == undefined) || (value == null)) {
        value = 0
    }

    let percent = parseFloat(value.toString().replace(/[^0-9\.-]/g, ''))
    if (isNaN(percent)) {
        percent = 0
    }

    return percentFormatter.format(percent)
}

/**
 * Format a nubmer to currency for use in a list of other UI dsiplay.
 * @param {Number} value A float value to format to currency, with grouping
 * @returns A formatted currency value ready for display in the UI.
 */
 export const formatCurrency = (value) => {
    if ((value == undefined) || (value == null)) {
        value = 0
    }

    let currency = parseFloat(value.toString().replace(/[^0-9\.\-]/g, ''))
    if (isNaN(currency)) {
        currency = 0
    }

    return currencyFormatter.format(currency)
}

/**
 * Format a nubmer for use in an HTML number input box.
 * @param {Number} value A value to format as an integer number with commas
 * @returns A formatted float value ready for an number input box.
 */
export const formatCount = (value) => {
    if ((value == undefined) || (value == null)) {
        value = 0
    }

    let count = parseFloat(value.toString().replace(/[^0-9\.-]/g, ''))
    if (isNaN(count)) {
        count = 0
    }

    return countFormatter.format(count)
}

/**
 * Format the given telephone number for display in the UI.
 * @param {String} digits 10-13 digits only of the phone number to format.
 * @returns A formatted telephone number
 */
export const formatPhone = (digits) => {
    if (!digits) {
        return '';
    }

    if (isNaN(digits)) {
        return digits;
    }

    if ((digits.length < 10) || (digits.length > 13)) {
        return digits;
    }

    if (digits.length == 10) {
        digits = '1' + digits;
    }

    let country = (digits.substring(0, digits.length - 10));
    let area = (digits.substring(digits.length - 10, digits.length - 10 + 3));
    let prefix = (digits.substring(digits.length - 7, digits.length - 7 + 3));
    let suffix = (digits.substring(digits.length - 4));

    return '+' + country + ' (' + area + ') ' + prefix + '-' + suffix;
}

/**
 * Format a phone number
 * @param {string} number The phone number to format.
 * @returns {number} The formatted phone number.
 */
export const formatLastVINDigits = (VIN, digits) => {
    return VIN.slice(-digits)
}

/**
 * Pretty print XML data for display in the UI.
 * @param {string} xml The xml data srringified and ready for pretty printing.
 * @param {string} [tab='\t'] The character(s) to use for tab.
 * @param {string} [nl='\n'] The character(s) to use for new lines.
 * @returns The formatted XML for display in a UI.
 */
export const formatXML = (xml, tab = '\t', nl = '\n') => {
    let formatted = '', indent = '';
    
    const nodes = xml.slice(1, -1).split(/>\s*</);
    if (nodes[0][0] == '?') {
        formatted += '<' + nodes.shift() + '>' + nl;
    }

    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (node[0] == '/') {
            indent = indent.slice(tab.length); // decrease indent
        }

        formatted += indent + '<' + node + '>' + nl;
        if (node[0] != '/' && node[node.length - 1] != '/' && node.indexOf('</') == -1) { 
            indent += tab; // increase indent
        }
    }
    return formatted;
}